import React from 'react';
import * as Yup from 'yup';

export const ContentConnectorValidatorSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'tooShort')
        .max(50, 'tooLong')
        .required('invalidName'),
});